import {
  API,
  API_START,
  API_END,
  ACCESS_DENIED,
  API_ERROR,
  SERVER_IN_MAINTENANCE
} from "./types";
import env from "../config/env";

const URL = env.apiUrl;

export const apiStart = label => ({
  type: API_START,
  payload: label
});

export const apiEnd = label => ({
  type: API_END,
  payload: label
});

export const serverInMaintenance = label => ({
  type: SERVER_IN_MAINTENANCE,
  payload: label
});

export const accessDenied = url => ({
  type: ACCESS_DENIED,
  payload: {
    url
  }
});

export const apiError = (error, label, data) => ({
  type: API_ERROR,
  error: error && error.message ? error.message : error,
  payload: label,
  data
});

export function apiAction({
  customUrl = null,
  url = "",
  method = "GET",
  data = null,
  onSuccess = () => {},
  onFailure = () => {},
  accessToken = null,
  label = "",
  headers = null,
  schema = null
}) {
  if (headers) {
    headers["Content-Type"] = "application/json";
  }
  return {
    type: API,
    payload: {
      url: customUrl ? customUrl : URL + url,
      method,
      data,
      accessToken,
      onSuccess,
      onFailure,
      label,
      headers,
      schema
    }
  };
}
